// extracted by mini-css-extract-plugin
export var dropdownButton = "_3y-0";
export var fullWidthDropdownButton = "_3y-1";
export var icon = "_3y-3";
export var iconPlaceholder = "_3y-2";
export var menuItemRow = "_3y-5";
export var shortcutContainer = "_3y-4";